import { DefaultResponse } from "../../types/default-response.dto";
import { createAuthClient } from "../auth/auth.client";
import {
  FETCH_DEPOSIT,
  INITIATE_DEPOSIT,
  REPORT_DEPOSIT,
  VERIFY_DEPOSIT,
} from "./deposit.queries";

export const getDeposit = async (
  depositId: string,
): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(FETCH_DEPOSIT, {
    depositId,
  });
};

export const initiateDeposit = async (
  depositAmount: number,
): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(INITIATE_DEPOSIT, {
    depositAmount,
  });
};

export const verifyDeposit = async (
  reference: string,
  currenyId: string,
): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(VERIFY_DEPOSIT, {
    reference,
    currenyId,
  });
};

export const reportDeposit = async (
  depositId: string,
  message: string,
): Promise<DefaultResponse> => {
  const authClient = createAuthClient();
  return authClient.request(REPORT_DEPOSIT, {
    depositId,
    message,
  });
};
